import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import BugReportForm from '../BugReportForm/BugReportForm';
import { useState } from 'react';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [showBugReport, setShowBugReport] = useState(false);
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-content">
        <nav className="footer-nav" aria-label="Footer Navigation">
          <ul>
            <li><a href="/">{t('home')}</a></li>
            <li><a href="/upload">{t('upload')}</a></li>
            <li><a href="/discussion">{t('discussion')}</a></li>
            <li><a href="/about">{t('About') || 'About'}</a></li>
            <li><a href="/contact">{t('Contact') || 'Contact'}</a></li>
            <li>
              <button className="bug-report-button" onClick={() => setShowBugReport(true)}>
                <span className="material-symbols-outlined">bug_report</span> {t('bug_report')}
              </button>
            </li>
          </ul>
        </nav>
        <div className="footer-lang">
          <button onClick={() => i18n.changeLanguage('vi')} className={i18n.language === 'vi' ? 'active' : ''}>VI</button>
          <button onClick={() => i18n.changeLanguage('en')} className={i18n.language === 'en' ? 'active' : ''}>EN</button>
        </div>
      </div>
      <address className="footer-address">
        <span>© {new Date().getFullYear()} FreeQuizAI</span> |
        <a href="mailto:support@freequizai.com" rel="noopener noreferrer">support@freequizai.com</a>
      </address>
      {showBugReport && (
        <BugReportForm onClose={() => setShowBugReport(false)} />
      )}
    </footer>
  );
};

export default Footer; 